import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";
import { ReactNode } from "react";

interface CustomDialogProps {
  trigger?: ReactNode; // <-- add this
  triggerLabel?: string;
  title?: string;
  description?: string;
  children: ReactNode;
  onSubmit?: (e: React.FormEvent<HTMLFormElement>) => void;
  onCancel?: () => void;
  submitLabel?: string;
  cancelLabel?: string;
  pagination?: {
    currentPage: number;
    totalPages: number;
    onPageChange: (page: number) => void;
  };
  width?: string;
  height?: string;
  open?: boolean;
  onOpenChange?: (open: boolean) => void;
}

export function CustomDialog({
  trigger,
  triggerLabel = "Open Dialog",
  title,
  description,
  children,
  onSubmit,
  onCancel,
  submitLabel,
  cancelLabel,
  pagination,
  width = "80",
  height = "90",
  open,
  onOpenChange,
}: CustomDialogProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      {trigger !== undefined && (
        <DialogTrigger asChild>
          {trigger ? trigger : <Button variant="outline">{triggerLabel}</Button>}
        </DialogTrigger>
      )}

      <DialogContent className= {`min-w-[${width}%] h-[${height}] max-h-[90vh] bg-white flex flex-col`}>
        {title && (
          <DialogHeader className="flex-shrink-0">
            <DialogTitle>{title}</DialogTitle>
            {description && (
              <DialogDescription>{description}</DialogDescription>
            )}
          </DialogHeader>
        )}
        <div className="flex-1 overflow-auto p-2">
          {children}
        </div>
        {pagination && pagination.totalPages > 1 && (
          <div className="flex-shrink-0 flex items-center justify-center gap-2 p-2 border-t">
            <Button
              variant="outline"
              size="sm"
              onClick={() => pagination.onPageChange(pagination.currentPage - 1)}
              disabled={pagination.currentPage === 1}
            >
              Previous
            </Button>
            <span className="text-sm text-muted-foreground">
              Page {pagination.currentPage} of {pagination.totalPages}
            </span>
            <Button
              variant="outline"
              size="sm"
              onClick={() => pagination.onPageChange(pagination.currentPage + 1)}
              disabled={pagination.currentPage === pagination.totalPages}
            >
              Next
            </Button>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
}
